import { ExternalActorType } from 'graphql-query-contracts';

/**
 * Custom error class for bulk invoice update operations
 */
export class BulkUpdateInvoicesToPaidError extends Error {
  constructor(message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'BulkUpdateInvoicesToPaidError';
  }
}

/**
 * GraphQL request payload structure
 */
export interface BulkUpdateInvoicesToPaidRequest {
  invoiceIds: string[];
  externalActorId: string;
  externalActorType: ExternalActorType;
}

/**
 * GraphQL response structure
 */
export interface BulkUpdateInvoicesToPaidResponse {
  successfulInvoiceIds: string[];
  failedInvoices: Array<{
    invoiceId: string;
    errorMessage: string;
  }>;
}

/**
 * Hook input parameters (simplified for consumer)
 */
export type BulkUpdateInvoicesToPaidInput = {
  invoiceIds: string[];
  externalActorId: string;
};

/**
 * Hook return result (enriched with computed fields)
 */
export type BulkUpdateInvoicesToPaidResult = {
  successCount: number;
  failureCount: number;
  successfulInvoiceIds: string[];
  failedInvoices: Array<{
    invoiceId: string;
    errorMessage: string;
  }>;
};

